import React from 'react'

import { Grid, TextField, Box, Typography } from '@material-ui/core'

import { useForm, Controller } from 'react-hook-form'

import moment from 'moment'

import { Select as SelectComponent } from 'components'

import helpers from 'helpers'

import schema from './schema'

import useSubscription from 'hooks/useSubscription'
import constants from 'constants/index'

import visaImg from 'images/visa.svg'
import mastercardImg from 'images/mastercard.svg'
import amexImg from 'images/amex.png'
import eloImg from 'images/elo.png'
import hipercardImg from 'images/hipercard.png'

const FormCreditCard = ({
  submitPayment,
  showBrands = true,
  formSubmitId = 'form-submit-main',
}) => {
  const months = constants.date.MONTHS.map((month) => ({
    id: month,
    name: month,
  }))
  const years = helpers.functions.yearsAhead(15).map((year) => ({
    id: year,
    name: year,
  }))

  const {
    setDisabledButton,
    toNextSubStep,
    activeSubStep,
    setActiveSubStep,
    setPayloadPayment,
  } = useSubscription()

  const { errors, control, handleSubmit, setError } = useForm({
    validationSchema: schema,
    defaultValues: {
      name: '',
      number: '',
      cvv: '',
      month: '',
      year: '',
      document: '',
    },
  })

  const handleSubmitAction = async (data) => {
    const methodPaymentByBrand = helpers.cardFlag.identify(data?.number)

    if (!methodPaymentByBrand) {
      setError('number', {
        type: {
          notMatch: 'Cartão de crédito inválido!',
        },
      })
      return
    }

    if (!dateIsValid(data.month, data.year)) return

    const expirationDate = `${data.month}/${data.year}`

    delete data.month
    delete data.year
    const payload = {
      method: methodPaymentByBrand,
      card: {
        ...data,
        expiration: expirationDate,
      },
    }
    setPayloadPayment(payload)
    await submitPayment(payload)

    if (!!setDisabledButton) {
      setDisabledButton(false)
    }
    if (!!toNextSubStep) {
      setActiveSubStep(activeSubStep + 1)
      toNextSubStep()
    }
  }

  const dateIsValid = (month, year) => {
    const currentYear = moment().year()
    const currentMonth = moment().month()
    year = parseInt(year)
    month = parseInt(month)

    if (year > currentYear) return true

    // O moment, retorna o mês com um valor a menos, se é Fev, ele retorna 1
    if (year === currentYear && month > currentMonth) return true

    setError('month', 'custom', 'Data inválida.')
    setError('year', 'custom', 'Data inválida.')

    return false
  }

  return (
    <form onSubmit={handleSubmit(handleSubmitAction)} id={formSubmitId}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                fullWidth
                error={!!errors.name}
                helperText={errors?.name?.message}
                label="Nome do Titular"
                alt="Nome do titular do cartão de crédito"
              />
            }
            control={control}
            name="name"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                fullWidth
                error={!!errors.document}
                helperText={errors?.document?.message}
                label="CPF/CNPJ do Titular"
                alt="CPF ou CNPJ do titular do cartão de crédito"
              />
            }
            onChange={([event]) =>
              helpers.formatters.document.identify(event.target.value, true)
            }
            control={control}
            name="document"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                fullWidth
                inputProps={{
                  maxLength: 19,
                }}
                error={!!errors.number}
                helperText={
                  errors?.number?.message ||
                  errors?.number?.types?.type?.notMatch
                }
                label="Número do Cartão"
                alt="Número do cartão de crédito"
              />
            }
            onChange={([event]) => {
              return helpers.formatters.creditCardNumber(event.target.value)
            }}
            control={control}
            name="number"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Controller
            name="month"
            control={control}
            as={
              <SelectComponent
                items={months}
                error={!!errors.month}
                fullWidth
                helperText={errors.month?.message}
                label="Mês (MM)"
                alt="Mês de expiração"
              />
            }
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Controller
            name="year"
            control={control}
            as={
              <SelectComponent
                items={years}
                error={!!errors.year}
                fullWidth
                helperText={errors.year?.message}
                label="Ano (AA)"
                alt="Ano de expiração"
              />
            }
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <TextField
                fullWidth
                inputProps={{
                  maxLength: 4,
                }}
                error={!!errors.cvv}
                helperText={errors?.cvv?.message}
                label="Código de segurança (CVV/CVC)"
                alt="Código de segurança"
              />
            }
            control={control}
            name="cvv"
            mode="onChange"
          />
        </Grid>
        {showBrands && (
          <Grid item xs={12}>
            <Box m={1}>
              <Typography variant="h6">Bandeiras aceitas</Typography>
              <Box display="flex" alignItems="center" flexDirection="row">
                <Box mr={1}>
                  <img src={visaImg} alt="bandeira visa" width={55} />
                </Box>
                <Box mr={1}>
                  <img
                    src={mastercardImg}
                    alt="bandeira mastercard"
                    width={40}
                  />
                </Box>
                <Box mr={1}>
                  <img src={eloImg} alt="bandeira elo" width={40} />
                </Box>
                <Box mr={1}>
                  <img
                    src={amexImg}
                    alt="bandeira AMEX (American Express)"
                    width={40}
                  />
                </Box>
                <Box>
                  <img src={hipercardImg} alt="bandeira hipercard" width={55} />
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </form>
  )
}

export default FormCreditCard
